import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import * as serviceWorker from "./serviceWorker";
import App from "./App";

// Create the root using `createRoot` and render your app
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

serviceWorker.unregister();
